import { Factory, trait } from 'miragejs';
import { FlowType } from 'garaje/utils/enums';
import { v4 as uuid } from 'uuid';

const DEFAULT_DENIED_MESSAGE = 'Default message!';

export default Factory.extend({
  name: () => 'Employee registration',
  employeeScreeningRequired: false,
  __flowUUID: () => uuid(),

  afterCreate(employeeScreeningFlow, server) {
    let flow = server.schema.flows.findBy({ __flowUUID: employeeScreeningFlow.__flowUUID });
    if (!flow) {
      flow = server.create('flow', 'asEmployeeRegistration', {
        employeeScreeningFlow: true,
        name: employeeScreeningFlow.name,
        type: FlowType.EMPLOYEE_REGISTRATION,
        enabled: employeeScreeningFlow.enabled,
        location: employeeScreeningFlow.location,
        locations: employeeScreeningFlow.locations,
        __flowUUID: employeeScreeningFlow.__flowUUID,
      });
      if (employeeScreeningFlow.id !== flow.id) {
        const originalId = employeeScreeningFlow.id;
        employeeScreeningFlow.update({ id: flow.id });

        // updating the ID can create another model with the new ID; destroy the original so we don't end up with more records than we expect
        server.schema.employeeScreeningFlows.find(originalId)?.destroy();
      }
    }
  },

  withSummaryPage: trait({
    afterCreate(flow, server) {
      flow.summaryPage = server.create('summary-page', {
        flow,
        message: DEFAULT_DENIED_MESSAGE,
        defaultMessage: DEFAULT_DENIED_MESSAGE,
        kind: 'none',
      });
    },
  }),

  withAgreementPage: trait({
    afterCreate(flow, server) {
      flow.agreementPage = server.create('agreement-page', {
        flow,
      });
    },
  }),

  withSignInFieldPage: trait({
    afterCreate(flow, server) {
      flow.signInFieldPage = server.create(
        'sign-in-field-page',
        'withEmailAddressSignInField',
        'withFullNameSignInField',
        'withSingleSelectionSignInField',
        { flow }
      );
    },
  }),
});
